<template>
  <div>
    <el-col :span="24">
      <div class="titleTop">
        <h5 style="margin: 0;">
          Data related literatures
        </h5>
      </div>
    </el-col>
    <el-col :span="24" style="height: 350px;">
      <el-carousel
        style="text-align: center;"
        type="card"
        :interval="4000"
        height="340px"
        indicator-position="none"
        arrow="never"
      >
        <el-carousel-item
          v-for="item in literatureList"
          :key="item.id"
          :title="item.title"
          style="cursor:pointer;"
        >
          <img style="margin-top:30px;height: 240px;" :src="indexImgPath + item.imgUrl" @click="toLink(item.url)" />
          <p style="margin-top:30px; width: 400px;text-alien:center;margin-left:auto;margin-right:auto;" @click="toLink(item.url)">{{ item.title }}</p>
        </el-carousel-item>
      </el-carousel>
    </el-col>
  </div>
</template>
<script>
import { pathConfig } from '../assets/util/baseConfig'

export default {
  props: ['literatureList'],
  data() {
    return {
      indexImgPath: pathConfig.indexImgPath
    }
  },
  methods: {
    toLink(url) {
      window.open(url, '_blank')
    }
  }
}
</script>
<style  scoped>
.seamless-warp2 {
  overflow: hidden;
  height: 200px;
  border: 1px solid #e0dddd;
}

li {
  float: left;
  margin-right: 10px;
  width: 183px;
  height: 200px;
}
.ul-item {
  list-style: none;
  margin: 0;
  padding: 0;
  width: 1580px;
}
.logo {
  height: 100px;
  margin-top: 25px;
  border-radius: 50%;
  background: #eeeeee;
  box-shadow: 0 0 8px 4px #d0d0d0;
}
.logoTitle {
  display: inline-block;
  width: 100px;
  text-align: center;
  margin-top: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/bottomLiteratures.vue